module.exports = __webpack_public_path__ + "static/media/info.1aa7351a.svg";